import all from './all';
import items from './items';
import store from './store';
import bulkStore from './bulkStore';
import show from './show';
import update from './update';
import destroy from './destroy';
import deduct from './deduct';

export default {
  all,
  items,
  store,
  bulkStore,
  show,
  update,
  destroy,
  deduct,
};



// WEBPACK FOOTER //
// ./src/app/services/batchIngredience/index.js